
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".8","d":"M7.219 4.344H14V3H5.875l1.344 1.344zm3.343 3.312H12V6.344H9.219l1.344 1.312zM9.345 10.22V11H6.656V9.656h2.125l-2-2H4V6.344h1.438l-2-2H2V3h.125L.937 1.812l.938-.937 12.25 12.25-.938.938-3.843-3.844z"}})])
          )
        }
      }
    